import { extractDomain } from "./utils";

export const leftSectionOptions: {
  label: string;
  url?: string;
  options?: {
    label: string;
    url: string;
  }[]
}[] = [
  // {
  //   label: "Search",
  //   options: [
  //     {
  //       label: "Search",
  //       url: `${extractDomain()}/edge/recruiter/search-v1`,
  //     },
  //     {
  //       label: "Save searches",
  //       url: `${extractDomain()}/edge/foldermanagement/manage-save-search `,
  //     },
  //   ],
  // },
  {
    label: "Search",
    url: `${extractDomain()}/edge/recruiter-search/search`,
  },
  {
    // label: "Job Posting",
    label: "Job",
    options: [
      {
        label: "Post a job",
        url: `${extractDomain()}/edge/jobposting/new-job-posting?origin=Header menu`,
      },
      {
        label: "Manage jobs",
        url: `${extractDomain()}/edge/managejobposting`,
      },
      {
        label: "Manage questionnaire",
        url: `${extractDomain()}/edge/jobposting/manage-questionnaire`,
      },
    ],
  },
  {
    label: "Campaign",
    url: `${extractDomain()}/edge/recruiter-outreach-email/campaing/listing`,
  },
  {
    label: "Folders",
    url: `${extractDomain()}/edge/foldermanagement/manage-folder`,
  },
  // {
  //   label: "Skill Assessment",
  //   url: `${extractDomain()}/skillyst`,
  // },
  {
    label: "Reports",
    url: `${extractDomain()}/edge/reports`,
  },
];

// for logout header
export const leftSectionOptionsLO = [
  {
    label: "Product",
    options: [
      {
        label: "Talent solutions",
        url: `${extractDomain()}/talent-solutions`,
      },
      {
        label: "Employer branching",
        url: `${extractDomain()}/employer-branding`,
      },
      {
        label: "Sprynt by foundit",
        url: `${extractDomain()}/solution/sprynt`,
      },
    ],
  },
  {
    label: "Resource Center",
    options: [
      {
        label: "Platform guide",
        url: `https://www.foundithub.com`,
      },
      {
        label: "Foundit insights tracker",
        url: `${extractDomain()}/career-advice/insights-tracker`,
      },
      {
        label: "Sort survey report",
        url: `${extractDomain()}/event/sort-survey`,
      },
    ],
  },
  {
    label: "Help",
    url: `${extractDomain()}/v2/SelfHelp`,
  },
  {
    label: "Testimonials",
    url: `${extractDomain()}/testimonial`,
  },
  {
    label: "Skill Assessment",
    url: `${extractDomain()}/skillyst`,
  },
  {
    label: "Job Seeker Login",
    url: `${extractDomain()}/rio/login`,
  },
];

export const getInitials = (name?: string) => {
  if (!name) return "";
  const nameList = name.trim().split(" ");
  if (nameList[0]?.[0] && nameList[1]?.[0]) {
    return `${nameList[0][0]}${nameList[1][0]}`;
  } else if (nameList[0]?.[0]) {
    return `${nameList[0][0]}${nameList[0][1] || ""}`;
  } else if (nameList[1]?.[0]) {
    return `${nameList[1][0]}${nameList[1][1] || ""}`;
  }
  return "";
};

export const getKnowledgeHubUrl = (currentUrl: string) => {
  const knowledgeHubUrl = "https://www.foundithub.com/";
  // const knowledgeHubUrl = currentUrl?.includes(".in")
  //   ? "https://www.foundithub.com/"
  //   : currentUrl?.includes("gulf")
  //   ? "https://gulf.foundithub.com/"
  //   : "https://sea.foundithub.com/";

  return knowledgeHubUrl;
};
